import strings from "../../global/constants/StringConstants";
import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall, makeCallFile } from "../../utils/service";

export const getAnalysisData = async (profileId: string, language: string) => {
  const url = `${urls.analysisData}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getMineralsData = async (profileId: string, language: string) => {
  const url = `${urls.missingMinerals}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getMahadashaData = async (profileId: string, language: string) => {
  const url = `${urls.mahadashaData}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getPranadashaData = async (
  profileId: string,
  language: string,
) => {
  const url = `${urls.pranadashaData}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getInnerDashaData = async (
  innerDashaObject: any,
  language: string,
) => {
  try {
    const callParams = await getCallParams("POST", innerDashaObject);
    const response = await makeCall(
      `${urls.innerDashaCosmicData}/${language}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

const getUrl = (subTabValue: string) => {
  switch (subTabValue) {
    case strings.GOOD_TIME:
      return urls.beneficDashaData;
    case strings.BAD_TIME:
      return urls.maleficDashaData;
    case strings.CHANGES_IN_ONE_YEAR:
      return urls.threePlanetChangeData;
    case strings.CHANGES_IN_LIFE_SPAN:
      return urls.threePlanetChangeLifeData;
  }
};

export const getSingleDashaComponentData = async (
  profileId: string,
  subTabValue: string,
  downloadParameters: string,
  language: string,
) => {
  const url = `${getUrl(
    subTabValue,
  )}/${profileId}/${downloadParameters}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    if (
      downloadParameters === "pdf" ||
      downloadParameters === "image" ||
      downloadParameters === "zip"
    ) {
      const response = await makeCallFile(url, callParams);
      console.log("Response from makeCallFile:", response);
      return response;
    } else {
      const response = await makeCall(url, callParams);
      return response;
    }
  } catch (error: any) {
    throw error;
  }
};

export const getBuyNowUrl = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.buyNowUrl, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getPlanetData = async (profileId: string, language: string) => {
  const url = `${urls.planetData}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getIndividualPlanetData = async (
  profileId: string,
  planet: string,
  language: string,
) => {
  const url = `${urls.individualPlanetData}/${profileId}/${planet}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export async function getCircularChart(profileId: string, language: string) {
  const url = `${urls.circularChart}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export const getIndividualHousesData = async (
  profileId: string,
  planet: string,
  language: string,
) => {
  const url = `${urls.individualHouseData}/${profileId}/${planet}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getArudhaPadaData = async (
  profileId: string,
  language: string,
) => {
  const url = `${urls.arudhaPada}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getShadbalaData = async (profileId: string) => {
  const url = `${urls.shadbala}/${profileId}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getKarmicResourcesData = async (data: any) => {
  try {
    const callParams = await getCallParams("POST", data);
    const response = await makeCall(urls.karmicResources, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getKarmicResourcesCustomData = async (data: any) => {
  try {
    const callParams = await getCallParams("POST", data);
    const response = await makeCall(urls.karmicResourcesCustom, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getVedicAspectsData = async (
  profileId: string,
  language: string,
) => {
  const url = `${urls.vedicAspects}/${profileId}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
